import React, { useEffect } from "react";
import styles from "./callsInnerTop.module.scss";
import { Dropdown, Menu, Tooltip } from "antd";
import statusimg from "../../../../styles/images/profile-status-icon.svg";
import teamImg from "../../../../styles/images/TeamProfilePic.png"
import { useState } from "react";
import { useSelector } from 'react-redux';
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { useHistory } from "react-router-dom";
import { URvoicemailSkeletonTop } from "../../../../shared/skeletonLoading/voicemailSkeletonTop";
import { initiateCall, initiateGroupCall, sendDirectVideoCallRequest } from "../../../../base/callService/callService";
import { gotoChat, makeFavourite, toastInformation, userStatusColor } from "../../../../base/callService/common";
import { callMainWindowState } from "../../../../models/callModel";
import { config } from "../../../../base/constant";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import { UserDetails,initialStateModel } from "../../../../models/model";
import { handleMute, unmuteNotification } from "../../../../base/socketChatService/utils";
import { storeChatWindow } from "../../../../base/callService/store_mining";
import RightArrow from "../../../../styles/svgIcons/sample";
import singleIcon from "../../../../styles/images/Welaunch_Profile_Pic.svg";
import pstn from "../../../../styles/images/nonamecall.svg";
import store from "../../../../context/store/store";
import teamIcn from "../../../../styles/images/teamimg.svg"

export default function CallsInnerTop() {
  const{planBased}= useSelector((state:any) => state.meetingReducer);
  const [name, setName] = useState(false);
  const [groupCallBtnDisable, setGroupCalBtnDisable] = useState(false);


  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);
  let { isParticularLoading, particularLog ,callHistory} = callReducer;
  let loggeduser: UserDetails = store.getState().loginReducer.userdetails || [];
  const history = useHistory();
  function profileFullview() {
    setName(!name);
  }
  const { callPermissionDetail}: callMainWindowState
    = useSelector((state: callMainWindowState) => state);

  useEffect(() => {
  // {Call Log Middle log Callicon}
    const GroupCallFeature = planBased.find((item:any) => item.featureid === 49);
    if (GroupCallFeature && GroupCallFeature.value1 === "Yes") {
      setGroupCalBtnDisable(false); 
    } else {
      setGroupCalBtnDisable(true);
    }
    
  }, [planBased])
  
  
  let { flipDeviceInfo } = callPermissionDetail || [];
  
  const toMail = (mail: any) => {
    let url ='mailto:'+ mail;
    window.open(url);
  };

  const videoMeetTrigger = (data:any) =>{
    if(data?.ext) { 
      sendDirectVideoCallRequest(data);  
  }
    else { toastInformation("Please check the number","failure"); }
  }
  let result:any =[];
  result = callHistory.map((item:any)=>{
   if(item.ext !== loggeduser.ext)
   {
      return parseInt(item.ext);
    
   }
  });
  const arr:any = result.filter((item:any)=>item !== undefined)
  const team_members:any = Array.from(new Set(arr))
  const internal:any=team_members.filter((elem:any)=>{return elem.toString().length === 3})
  const external:any=team_members.filter((elem:any)=>{return elem.toString().length !== 3})

  let merged_Obj :any ={...particularLog,...callHistory}
  return (
    <>{!isParticularLoading ? <>
      <div className={styles.mainprofiles}>
        <div className={name ? `${styles.profiledetails} ${styles.profileDetailsView}` : `${styles.profiledetails}`}>
          {/* <div className={styles.avatarset}><img src={particularLog?.profile_url} alt=""/><span></span></div> */}
          {/* <RightArrow /> */}
          {particularLog?.is_blocked === 1 ?     <URAvatarGroup className={`${'lefts size82'} ${styles.avatarset}`} profileInfo={
           <img src={singleIcon} alt="" />
} />:
          <URAvatarGroup className={`${'lefts size82 colorBG1'} ${styles.avatarset}`} profileInfo={particularLog?.serviceType!=="GroupCall" ?<>
                {/* {
                  ((particularLog?.sip_login_id) &&  (particularLog?.profile_image_thumbnail!== "")) ?
                    <img src={particularLog?.profile_image_thumbnail} alt="" /> :
                    (particularLog?.sip_login_id === "") ?
                    <img src={pstn} alt="" />:
                    <span >{particularLog?.first_name?.charAt(0).toUpperCase() + particularLog?.last_name?.charAt(0).toUpperCase()}</span>

                    
                } */}
                {
  ((particularLog?.sip_login_id) && (particularLog?.profile_image_thumbnail !== "")) ?
    <img src={particularLog?.profile_image_thumbnail} alt="" /> :
    (particularLog?.sip_login_id === "") ?
      <img src={pstn} alt="" /> :
      (particularLog?.first_name && particularLog?.last_name ?
        <span>{particularLog?.first_name?.charAt(0).toUpperCase() + particularLog?.last_name?.charAt(0).toUpperCase()}</span> :
        <img src={pstn} alt="" />) 
}

<URStatusDot className={userStatusColor(particularLog?.user_status, 'small')} /></>
            : <> {particularLog?.ImageURL && particularLog?.ImageURL !=='' ? 
            <img src={particularLog?.ImageURL} alt="" />:
            <span className="teamImg"><img className="ifDummy" src={teamIcn} alt="team icon" /></span> } 
              <URStatusDot className={userStatusColor(particularLog?.user_status,'small')}/></>
} /> }
          {/* <div className={`${styles.usergroups}`}><span>D</span></div> */}
          {particularLog?.sip_login_id ?  <div className={styles.userDt}>
            {/* <Tooltip placement="top" title={particularLog?.callerId||particularLog?.caller_id} > */}
            <p className={styles.userName} onClick={()=>storeChatWindow(particularLog)}
              title="View contact details">{particularLog?.groupId ?  particularLog?.ext === loggeduser.ext ? 'You + Others':particularLog?.caller_id.split(' ')[0] + ' + Others':(particularLog?.caller_id)}</p>
               {/* </Tooltip> */}

            <Tooltip placement="top"
              title={particularLog?.is_favourite === 1 ? "Remove Favourite" : 'Add Favourite'}>
              <span className={`${ particularLog?.is_favourite === 1 ?
               `icon_starfill cgreen ${styles.active} ` : 'icon_star'} ${particularLog?.is_blocked === 1 && 'blockdisabled'}`}
                onClick={() => makeFavourite(particularLog?.is_favourite === 0 ? 1 : 0,particularLog)}>
              </span></Tooltip>
             {(particularLog?.is_muted === 0) ?
                        <Tooltip placement="top" title={((particularLog?.is_muted === 0) )&& "Mute all notifications"}>
                            <Dropdown trigger={["click"]} overlay={ <Menu onClick={(e:any)=>handleMute(e,particularLog)}>
                            <Menu.Item key={"Until 8:00 AM"}>Until 8:00 AM</Menu.Item>
                            <Menu.Item key={"1 Hr"}>1 Hr</Menu.Item>
                            <Menu.Item  key={"12 Hr"}>12 Hrs</Menu.Item>
                            <Menu.Item key={"1 Week"}>1 Week</Menu.Item>
                            <Menu.Item key={"Always"}>Always</Menu.Item>
                            </Menu>} placement="bottomCenter"><span className={((particularLog?.is_muted === 0)) ?
                                styles.bellNotification : ` ${styles.bellNotification} ${styles.active}`}></span></Dropdown>
                        </Tooltip>
                    :
                      (particularLog?.is_muted=== 1 )&&
                      <Tooltip placement="top" title="Unmute all notifications">
                          <span onClick={()=>unmuteNotification(particularLog)} className={((particularLog?.is_muted===1 && particularLog?.sip_login_id) )?` ${styles.bellNotification} ${styles.active}`: styles.bellNotification}></span>
                        </Tooltip> }
          </div>
        :
        <div className={styles.userDt}>
            <p className={styles.userName} onClick={()=>storeChatWindow(particularLog)}
              title="View contact details">{particularLog?.ext === loggeduser.ext? `You + Others` : ""}</p>
              </div>
          
        }
          <div className={styles.actionIcon} >
          <div className={`${styles.callIcon} ${particularLog?.is_blocked === 1 && 'blockdisabled'} ${particularLog?.is_blocked === 1 && 'blockdisabled'} ${( groupCallBtnDisable && particularLog?.groupId !== "") === true ? 'disabledIcon' :'' }`} onClick={()=>particularLog?.serviceType==='GroupCall'?initiateGroupCall('multi', internal,external) :initiateCall(particularLog?.ext, 'audio')}>
              <span></span> Call</div>
            {particularLog?.sip_login_id && particularLog?.serviceType !=="GroupCall" &&
            <><div className={`${styles.chatIcon} ${particularLog?.is_blocked === 1 && 'blockdisabled'}` }
              onClick={()=>particularLog.serviceType==='GroupCall'?toastInformation('Future implmentation'): gotoChat(particularLog, history,'')} ><span></span> Chat</div>
            <div className={`${styles.meetIcon} ${particularLog?.is_blocked === 1 && 'blockdisabled'}`} onClick={()=>videoMeetTrigger(particularLog)}><span></span> Meet</div>
            </>}
          </div>
          {/* <div className={styles.actionIconImg} >
            <div className={styles.callIcon} >
            <img src={call} alt="" /> Call</div>
            <div className={styles.chatIcon}
               ><img src={chat} alt="" /> Chat</div>
            <div className={styles.meetIcon}><img src={meet} alt="" /> Meet</div>            
          </div> */}
          <div className={styles.profileDt}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Department</p>

              </div>
              <div className={styles.rightsidetxt}>
                <p>{particularLog?.department ? particularLog?.department : "Not Available"}</p>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Extension</p>
              </div>
              <div className={styles.rightsidetxt}>
              <div className={styles.phoneNumbrtxt}>
                  <p onClick={() => initiateCall(particularLog?.ext, 'audio')} >{particularLog?.ext}</p>
                  </div>
              </div>
            </div>
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>My Numbers</p>
              </div>
              {/* <div className={styles.rightsidetxt}> */}
                {/* <div className={styles.phoneNumbrtxt}> */}
                  {/* <Tooltip placement="top" title="Company number">
                    <p>{particularLog?.direct_no ? particularLog?.direct_no : "Not Available"}</p>
                    </Tooltip>
                  <Tooltip placement="top" title="Mobile number"><p>{particularLog?.mobileno}</p>
                  </Tooltip> */}



                  {/* { (particularLog?.is_muted === 0) ?
                        <Tooltip placement="top" title={((particularLog?.is_muted === 0) )&& "Mute all notifications"}>
                            <Dropdown trigger={["click"]} overlay={ <Menu onClick={(e:any)=>handleMute(e,particularLog)}>
                            <Menu.Item key={"Until 8:00 AM"}>Until 8:00 AM</Menu.Item>
                            <Menu.Item key={"1 Hr"}>1 Hr</Menu.Item>
                            <Menu.Item  key={"12 Hr"}>12 Hrs</Menu.Item>
                            <Menu.Item key={"1 Week"}>1 Week</Menu.Item>
                            <Menu.Item key={"Always"}>Always</Menu.Item>
                            </Menu>} placement="bottomCenter"><span className={((particularLog?.is_muted === 0)) ?
                                styles.bellNotification : ` ${styles.bellNotification} ${styles.active}`}></span></Dropdown>
                        </Tooltip>
                    :
                      (particularLog?.is_muted=== 1 )&&
                      <Tooltip placement="top" title="Unmute all notifications">
                          <span onClick={()=>unmuteNotification(particularLog)} className={((particularLog?.is_muted===1 && particularLog?.sip_login_id) )?` ${styles.bellNotification} ${styles.active}`: styles.bellNotification}></span>
                        </Tooltip> } */}
                {/* </div> */}
              {/* </div> */}
            </div>
            <div className={`${styles.rowFlex} `}>

            <div className={styles.leftsidetxt}>
                  <p>Active Device</p>
                </div>
                <div className={styles.rightsidetxt}>

                  {flipDeviceInfo?.length > 0 ?
                    (
                      flipDeviceInfo.map((elem: any, index: number) => {
                        return (
                          <div className={styles.deviceactive} key={index}>
                            {elem?.device_type === config().DESK_PHONE &&
                                <p><span className='icon_globe'></span> Desk Phone </p>}
                            {elem?.device_type === config().UR_ANDROID &&
                                <p><span className='icon_app'></span> Android</p>}
                            {elem?.device_type === config().UR_IOS &&
                                <p><span className='icon_app'></span> IOS </p>}
                          </div>
                        );
                      })
                    ) :(<p>Not Available</p>)
                  }
                </div>
            </div>
            
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>Email</p>
              </div>
              <div className={styles.rightsidetxt}>
                <div className={styles.emailtxt}>
                  <Tooltip placement="top" title={particularLog?.email_id}>
                    <p onClick={()=>toMail(particularLog?.email_id)}>{particularLog?.email_id}</p></Tooltip>
                </div>
              </div>
            </div>
          </div>
          {  particularLog?.status_msg &&  <div className={styles.workingStatus}>
              <StatusTag className='statusTag bgGrey' name={particularLog?.status_msg} />
              <span><img src={statusimg} alt="" /></span>
            </div>}
        </div>
        <div className={styles.clearLogLeft}>
          <div className={styles.checkBoxArea}>
            {/* <URCheckBox /> */}
          </div>
        </div>
      </div>
    </>:
      <URvoicemailSkeletonTop particularLog={particularLog} history={history}/>}
    </>
  );
};
